export function isNotEmpty(value) {
  if (typeof value === "string") {
    return value.trim() !== "";
  }
  return value !== null && value !== undefined;
}

export function hasLengthBetween(value, min = 0, max = Infinity) {
  if (typeof value !== "string") return false;
  const length = value.length;
  return length >= min && length <= max;
}

export function hasWordCountBetween(value, min = 0, max = Infinity) {
  if (typeof value !== "string") return false;
  const words = value.trim()
    ? value.trim().split(/\s+/).filter(Boolean).length
    : 0;
  return words >= min && words <= max;
}

export function isValidEmail(value) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
}

export function validateEmail(value) {
  const trimmedValue = value.trim();
  if (!trimmedValue) return "Email is required";

  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (!emailRegex.test(trimmedValue)) return "Invalid email address";
  return "";
}

export const MESSAGES = {
  FIRST_NAME_REQUIRED: "First name is required",
  LAST_NAME_REQUIRED: "Last name is required",
  POSITION_REQUIRED: "Position is required",
  COVER_REQUIRED: "Cover letter is required",
  COVER_LENGTH: "Cover letter must be 300-600 characters",
  FILE_REQUIRED: "CV is required",
  FILE_TOO_LARGE: "File size must be under 50MB",
  FILE_INVALID_TYPE: "Invalid file type. Allowed: PDF, DOC, DOCX, JPEG, PNG",
};

export function isAllowedFileType(file) {
  if (!file || !file.type) return false;
  const allowed = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "image/jpeg",
    "image/png",
  ];
  return allowed.includes(file.type);
}

export function isUnderMaxSize(file, maxBytes = 50 * 1024 * 1024) {
  if (!file || typeof file.size !== "number") return false;
  return file.size <= maxBytes;
}

export function validateFirstName(value) {
  return isNotEmpty(value) ? "" : MESSAGES.FIRST_NAME_REQUIRED;
}

export function validateLastName(value) {
  return isNotEmpty(value) ? "" : MESSAGES.LAST_NAME_REQUIRED;
}

export function validatePosition(value) {
  return isNotEmpty(value) ? "" : MESSAGES.POSITION_REQUIRED;
}

export function validateCoverLetter(value) {
  if (!isNotEmpty(value)) return MESSAGES.COVER_REQUIRED;
  if (!hasLengthBetween(value, 300, 600)) return MESSAGES.COVER_LENGTH;
  return "";
}

export function validateFile(file) {
  if (!file) return MESSAGES.FILE_REQUIRED;
  if (!isUnderMaxSize(file)) return MESSAGES.FILE_TOO_LARGE;
  if (!isAllowedFileType(file)) return MESSAGES.FILE_INVALID_TYPE;
  return "";
}
